import React from 'react';
import { makeStyles } from '@mui/styles';
import { remCalc } from '../../../util/style-util';
import { white, resourceDarkGray, resourceDarkGray2 } from '../../../styles/style-constants';
import { Resource } from 'types';
import UnpinIcon from 'assets/icons/UnpinIcon';
import BasicButton from '../../@common/Buttons/BasicButton';
import maybe from '../../../components/@common/enhancers/maybe';
import ResourceItemContent from './ResourceItemContent';
import ResourceItemFooter from './ResourceItemFooter';

type Props = {
  resource: Resource;
  hasUnpinIcon?: boolean;
  isFavoritePage?: boolean;
  onClick: () => void;
  onClickPinIcon?: (resource: Resource) => void;
  onRemoveItem?: (resource: Resource) => void;
  tabIndex?: number;
};

function ResourceItem(props: Props) {
  const { resourceItem, iconSvg, unpinIconDiv } = useStyles()();
  const MaybeUnpinButton: any = maybe(BasicButton);

  function handlePinItem() {
    if (props.onClickPinIcon) {
      props.onClickPinIcon(props.resource);
    }
  }

  function handleUnpinItem() {
    if (props.onRemoveItem) {
      props.onRemoveItem(props.resource);
    }
  }

  function handleTogglePinIcon(e: Event) {
    e.stopPropagation();
    if (props.hasUnpinIcon) {
      handleUnpinItem();
    } else {
      handlePinItem();
    }
  }

  function handleClickCloseIcon(e: Event) {
    e.stopPropagation();
    handleUnpinItem();
  }

  return (
    <div className={resourceItem} onClick={props.onClick} tabIndex={props.tabIndex}>
      <MaybeUnpinButton
        shouldRender={!!props.isFavoritePage}
        buttonStyles={[unpinIconDiv]}
        onClick={handleClickCloseIcon}
      >
        <UnpinIcon className={iconSvg} />
      </MaybeUnpinButton>
      <ResourceItemFooter
        resource={props.resource}
        isFavoritePage={props.isFavoritePage}
        hasUnpinIcon={props.hasUnpinIcon}
        onClickPinIcon={handleTogglePinIcon}
      />
      <ResourceItemContent resource={props.resource} />
    </div>
  );
}
const useStyles = () =>
  makeStyles(() => ({
    resourceItem: {
      backgroundColor: white,
      width: '100%',
      height: remCalc(220),
      padding: 0,
      display: 'flex',
      flexDirection: 'column',
      position: 'relative',
      boxShadow: '0px 3px 7px 1px' + resourceDarkGray,
      border: remCalc(1) + ' solid' + resourceDarkGray,
      borderRadius: remCalc(3),
      justifyContent: 'space-between',
      color: resourceDarkGray2,
      cursor: 'pointer',
      userSelect: 'none',
      '&:hover': {
        transform: 'scale(1.05, 1.05)'
      }
    },

    unpinIconDiv: {
      position: 'absolute',
      top: -10,
      right: -10,
      width: remCalc(35),
      height: remCalc(35),
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 2,
      padding: 0,
      border: 'none',
      cursor: 'pointer',
      backgroundColor: 'transparent',
      ':focus': {
        outline: 'none'
      }
    },
    iconSvg: {
      width: '100%',
      height: '100%'
    }
  }));

export default ResourceItem;
